import React from 'react';
import { Text } from '@ui';
export function FlagItem({ icon, title, description }) {
    return (React.createElement("li", { className: "tech-performance-drawer__flag" },
        React.createElement("i", { className: `fa-light ${icon} tech-performance-drawer__flag-icon`, "aria-hidden": "true" }),
        React.createElement("div", { className: "tech-performance-drawer__flag-body" },
            React.createElement(Text, { variant: "x-small", as: "div", className: "tech-performance-drawer__flag-title" }, title),
            description && (React.createElement(Text, { variant: "body", as: "div", className: "tech-performance-drawer__flag-desc" }, description)))));
}
